import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

export interface SegmentedTabOption<T = string> {
  value: T;
  label: string;
  /** Material icon name. Replaces the label; `label` becomes the accessible name. */
  icon?: string;
  tooltip?: string;
  /** Analytics hook applied to this tab (Pendo targets these). */
  pendoClass?: string;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-segmented-tabs',
  templateUrl: './segmented-tabs.component.html',
  styleUrls: ['./segmented-tabs.component.scss'],
})
export class SegmentedTabsComponent<T = unknown> {
  @Input() options: SegmentedTabOption<T>[] = [];
  @Input() value: T | null = null;
  @Input() idPrefix: string | null = null;
  /** `accent` = brand-green pill (forms/dialogs); `neutral` = grey pill (toolbar chrome). */
  @Input() variant: 'accent' | 'neutral' = 'accent';
  /** `md` = form sizing; `sm` = compact toolbar sizing with content-width tabs. */
  @Input() size: 'md' | 'sm' = 'md';
  @Output() valueChange = new EventEmitter<T>();
  /** Every click, including re-clicks on the active tab (e.g. re-opening a picker). */
  @Output() optionClick = new EventEmitter<T>();

  trackByValue = (_: number, opt: SegmentedTabOption<T>) => opt.value;

  tabId(value: T): string | null {
    return this.idPrefix ? `${this.idPrefix}-${String(value)}` : null;
  }

  onSelect(value: T): void {
    this.optionClick.emit(value);
    if (value === this.value) return;
    this.valueChange.emit(value);
  }
}
